/*
 * @Descripttion: 
 * @version: 
 * @Author: renyjk
 * @Date: 2020-07-15 21:13:42
 * @LastEditors: bbq
 * @LastEditTime: 2020-07-16 14:09:03
 */
import * as lib from './lib';
import CONFIG from './config';
import EditTableStore, { TableMeta, TableData } from './EditTableStore';
import * as utils from './utils';
import { handleSortcolumns } from './lib/sort/sort';

export { lib, CONFIG, EditTableStore, utils, TableMeta, TableData, handleSortcolumns };

import Table from '../../TableNext';

export * from '../../TableNext';
export default Table;